import { useEffect, useState } from 'react';

/**
 * Trailing-edge debounce for a value that drives a network request — a search
 * box, typically. Returns the previous value until `delayMs` has passed with no
 * further change, so typing "dataiku" issues one request rather than seven.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
